import React from "react";
import MapComponent from '../components/Map/Map';


const MobileMap = ({}) => {
    return(
        <div style={{ height: "100dvh", width: "100%" }}>
            <MapComponent />
        </div>
    )
}

export default MobileMap;
